<nav class="navbar navbar-expand-md navbar-light">
	<div class="menu-group collapse navbar-collapse" id="navbarSupportedContent">
		<a class="title_tld" routerLink="">TRAILER LOAD DIAGRAMS (TLD)</a>

		<!-- <a class="home" class="navbar-brand px-4" [routerLink]="['/home']" [ngClass]="activeHome? 'active' : '' ">
			<img src="./assets/images/home-grey.svg" *ngIf="enableHomeGrey" class="homeGrey">
			<img src="./assets/images/home-red.svg" *ngIf="enableHomeRed" class="homeRed"></a> -->


		<mat-nav-list class="headerinline">
			<div class="menuspacing" mat-list-item><a [routerLink]="['/actual']" routerLinkActive="active"
					#home="routerLinkActive" class="menu">Actual</a></div>
			<div class="menuspacing" mat-list-item><a [routerLink]="['/plan']" routerLinkActive="active"
					#plan="routerLinkActive" class="menu">Plan</a></div>
			<div class="menuspacing" mat-list-item><a [routerLink]="['/supp']" routerLinkActive="active"
					#supp="routerLinkActive" class="menu">Supplements</a></div>
			<div class="menuspacing" mat-list-item><a routerLink="finalpackage" routerLinkActive="active"
					#finalpackage="routerLinkActive" class="menu">Final Package</a></div>
		</mat-nav-list>



	</div>
</nav>